import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import './awards.css';

const Awards = () => {
  const [awards, setAwards] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "awards"));
        const data = {};
        querySnapshot.forEach((doc) => {
          data[doc.id] = doc.data();
        });
        setAwards(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching awards:", error);
      }
    };

    fetchAwards();
  }, []);

  if (loading) return null; // Or a simple spinner

  return (
    <section id='awards'>
      <div style={{ marginBottom: "2rem" }}>
        <div className='awards__header'>Awards</div>
        <div className='awards__description'>Accolades and Achievements</div>
        <div className='awards__content'>
          <div className='awards__text'>
            
            {/* SLOT 1 */}
            <div className='awards__container'>
              <img src={awards['1']?.image_url} className='awards__img' alt='Award 1' />
              <div className='indiv__section'>
                <p className='indiv__awards' style={{ fontWeight: "bold" }}>{awards['1']?.title}</p>
                <p className='indiv__awards'>{awards['1']?.description}</p>
              </div>
            </div>

            {/* SLOT 2 (Middle) */}
            <div className='awards__container__middle'>
              <img src={awards['2']?.image_url} className='awards__img' style={{ height: "5rem" }} alt='Award 2' />
              <div className='indiv__section'>
                <p className='indiv__awards' style={{ fontWeight: "bold" }}>{awards['2']?.title}</p>
              </div>
              <p className='indiv__text'>{awards['2']?.description}</p>
            </div>

            {/* SLOT 3 */}
            <div className='awards__container'>
              <img src={awards['3']?.image_url} className='awards__img' alt='Award 3' />
              <div className='indiv__section'>
                <p className='indiv__awards' style={{ fontWeight: "bold" }}>{awards['3']?.title}</p>
                <p className='indiv__awards'>{awards['3']?.description}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Awards;